import type { ISimpleFilterParams } from "ag-grid-community";

export const DEFAULT_FILTER = "agTextColumnFilter" as const;

export const DEFAULT_FILTER_PARAMS: ISimpleFilterParams = {
  buttons: ["reset", "apply"],
  closeOnApply: true,
} as const;

export const DEFAULT_CELL_RENDERER_PARAMS = { deferRender: false } as const; // When enabled the table looks like reloading (but it only renders the cells)

export const nonBreakingSpace = "\u00A0";
